export default __webpack_public_path__ + "static/media/motor4.e8c33d78.jpg";